var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _circle, _polygon, _path7, _path8, _path9, _circle2, _path0, _path1, _path10, _path11, _polygon2, _path12, _polygon3, _polygon4, _path13, _path14, _circle3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _polygon5, _path23, _path24, _circle4, _circle5, _circle6, _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path25, _circle7, _path26, _path27, _circle8, _path28, _path29, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDev1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8c09660-db65-4061-a2dc-920e909a0453",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1057.99365,
    height: 557,
    viewBox: "0 0 1057.99365 557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "web_development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000.12219,420.11243,899.99683,467.5l88.61529-66.2619a500.05588,500.05588,0,0,0-48.38385-63.66846L505.99683,445.5,898.23022,295.87646a499.98052,499.98052,0,0,0-56.95764-43.41418L179.60608,359.03943A495.88009,495.88009,0,0,0,71.00317,668.5h995.98731A495.6132,495.6132,0,0,0,1000.12219,420.11243Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M787.12,221.69537A495.97179,495.97179,0,0,0,568.99683,171.5c-153.82965,0-291.36139,69.75269-382.71033,179.34869C342.71289,316.57422,615.06372,257.24316,787.12,221.69537Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.99683,666.5c0,15.464-143.7166,62-321,62s-321-46.536-321-62,143.71659,6,321,6S1066.99683,651.036,1066.99683,666.5Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.99683,666.5c0,15.464-143.7166,62-321,62s-321-46.536-321-62,143.71659,6,321,6S1066.99683,651.036,1066.99683,666.5Z",
    transform: "translate(-71.00317 -171.5)",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 674.99365,
    cy: 495,
    rx: 321,
    ry: 28,
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M656.64413,438.62638s12.91086,20.47705,8.29993,26.02136,34.59341,5.68291,34.59341,5.68291-5.88892-29.78793-4.15568-36.64328Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M656.64413,438.62638s12.91086,20.47705,8.29993,26.02136,34.59341,5.68291,34.59341,5.68291-5.88892-29.78793-4.15568-36.64328Z",
    transform: "translate(-71.00317 -171.5)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 606.27433,
    cy: 234.063,
    r: 40.48447,
    fill: "#ff6584"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "701.494 453.5 701.494 477.5 725.494 472.5 723.494 455.5 701.494 453.5",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M857.49683,629l67,11-17,25s-47-16-59-16S857.49683,629,857.49683,629Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M705.49683,581s50-58,66-55,23,21,23,21l9,89s-32,3-32,0-6-67-6-67-47,104-72,35Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M624.49683,620s1,50,31,53,63-20,63-20l54-25.87008s64,33.87008,83,24.87008c0,0,20-21,7-27s-1,0-1,0l-77-40s-15-4-41,7-61,16-61,16Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.49365,
    cy: 247.5,
    r: 30,
    fill: "#ffb8b8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M717.49683,503l-2,42s1,55-8,59c-4.55,2.02-13.69,6.08-22.14,10.52-6.34,3.32-12.29,6.84-15.61,9.87a11.19431,11.19431,0,0,0-2.25,2.61c-4,7-30,6-36,1s-2,6-7,8c-4.84,1.94-11.55-13.92-7.44-37.6.13-.79.28-1.59.44-2.4,4.59-22.95-2.62-77.92-1.51-99.16a37.36888,37.36888,0,0,1,.51-4.84c3-16,41.28-48.56,48.44-34.69,8.82,17.12,29.08,1.48,32.56-6.31,20-1,27,23,27,23Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#3f3d56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M798.49683,640s-16,6-21,5-10,3-10,9-6,20,3,21,46-1,54,2c0,0,36,1,33-14s-18-14-18-14S798.49683,647,798.49683,640Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M915.49683,643s2-6,5-6,27,4,30,3,38-3,32,14-26,19-26,19-36-4-41-3-23,0-20-5S917.49683,651,915.49683,643Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M824.47088,499.36345l5.48617,22.63046a1.41354,1.41354,0,0,1-.02746.76382l-24.88642,77.77a1.4135,1.4135,0,0,1-2.75071-.2712l-3.44274-30.29616a1.41351,1.41351,0,0,1,.06051-.59751l22.843-70.10435A1.4135,1.4135,0,0,1,824.47088,499.36345Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#d0cde1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "751.45 329.775 756.515 349.191 734.565 420.104 729.5 398.155 751.45 329.775",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M711.862,606.80006c.84421,2.53261,87.79721-.8442,88.64141-1.68841a18.32436,18.32436,0,0,0,1.85721-3.37681c.7936-1.68841,1.51961-3.37682,1.51961-3.37682l-3.37682-27.33532-86.1088-3.056s-2.15276,23.165-2.59176,33.76816A25.33138,25.33138,0,0,0,711.862,606.80006Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#d0cde1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "718.526 403.22 720.214 426.858 682.225 426.858 682.225 403.22 718.526 403.22",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "669.562 410.818 669.789 410.773 668.718 420.949 647.612 420.949 647.612 410.818 669.562 410.818",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M711.862,606.80006c.84421,2.53261,87.79721-.8442,88.64141-1.68841a18.32436,18.32436,0,0,0,1.85721-3.37681H711.80287A25.33138,25.33138,0,0,0,711.862,606.80006Z",
    transform: "translate(-71.00317 -171.5)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M698.40919,333.5a22.12987,22.12987,0,0,1-12.76894,8.778c-8.929,2.391-.07293,15.80887-.07293,15.80887s-3.22041-4.87923,1.42459-10.04646S699.1119,339.34049,698.40919,333.5Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ff6584"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.98182,
    cy: 189.80566,
    r: 11.28256,
    fill: "#ff6584"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M698.38979,370.7623c-9.19775-3.47892-24.51282-5.2429-32.392-4.03709l1.0806-7.8905c7.57488,3.91493,22.81967,5.7547,32.392,4.03709Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M680.59215,373.5867s-11.52728,19.17376-38.3321,26.35147-.219,47.45791-.219,47.45791-9.66758-14.64735,4.27659-30.15928S682.70167,391.11973,680.59215,373.5867Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ff6584"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M681.507,372.42157s11.07394,26.336,23.2314,28.82592,11.23534,44.10345-7.777,50.34359c0,0,13.86347-24.39564,2.01338-40.75671S679.6396,381.53967,681.507,372.42157Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ff6584"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M685.35681,614.52c-2.47,4.67-5.37,9.52-5.86,11.48-.33,1.33-3.99.56-9.75-1.61-11.55-4.37-31.57-14.38-50.25-24.39a15.775,15.775,0,0,1-2.44-1.6c.13-.79.28-1.59.44-2.4,4.59-22.95-2.62-77.92-1.51-99.16l8.51-2.84,17,16v68s44,24,47,26C690.02686,605.02,687.91681,609.67,685.35681,614.52Z",
    transform: "translate(-71.00317 -171.5)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M722.49683,560l27,14s16-17,26-4-29,17-29,17-34-8-35-19S722.49683,560,722.49683,560Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M677.49683,597l16,4s18-22,37-14-24,24-24,24-23,12-32,2S677.49683,597,677.49683,597Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#ffb8b8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M712.49683,465c1,1,12,9,12,9s3,38-1,46-7,8-4,12,7,1,3,8-8,6-5,9,2,4,2,4l12,10s-7.3623,11.72633-16.68115,10.86317S697.49683,528,697.49683,528Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M624.49683,489l-9,3s-24,88,4,103,59,30,60,26,12-20,9-22-47-26-47-26V505Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "566.994 354 564.994 402 617.994 427 568.994 402 566.994 354",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.09713,633.143c-20.15507,11.88443-28.08825,35.77412-28.08825,35.77412s24.74464,4.62122,44.8997-7.26321,28.08825-35.77412,28.08825-35.77412S1104.25219,621.2586,1084.09713,633.143Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.15958,640.51126c-11.28676,20.49574-34.9329,29.12782-34.9329,29.12782s-5.34669-24.59808,5.94007-45.09382,34.9329-29.12782,34.9329-29.12782S1102.44634,620.01553,1091.15958,640.51126Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#44bba4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.99365,
    cy: 228,
    r: 4,
    fill: "#44bba4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.99365,
    cy: 228,
    r: 4,
    fill: "#44bba4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.99365,
    cy: 228,
    r: 4,
    fill: "#44bba4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.99365,
    y: 378.87255,
    width: 58,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.99365,
    y: 391.87255,
    width: 54.86486,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.99365,
    y: 404.87255,
    width: 39.97297,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.99365,
    y: 378.87255,
    width: 58,
    height: 6,
    fill: "#44bba4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.99365,
    y: 391.87255,
    width: 54.86486,
    height: 6,
    fill: "#44bba4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.99365,
    y: 404.87255,
    width: 39.97297,
    height: 6,
    fill: "#44bba4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.99365,
    y: 378.87255,
    width: 58,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.99365,
    y: 391.87255,
    width: 54.86486,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.99365,
    y: 404.87255,
    width: 39.97297,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 353.99365,
    y: 378.87255,
    width: 58,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 353.99365,
    y: 391.87255,
    width: 54.86486,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 353.99365,
    y: 404.87255,
    width: 39.97297,
    height: 6,
    fill: "#44bba4",
    opacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.99365,
    y: 300.87255,
    width: 74,
    height: 66,
    fill: "#44bba4",
    opacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 205.99365,
    y: 300.87255,
    width: 74,
    height: 66,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 345.99365,
    y: 300.87255,
    width: 74,
    height: 66,
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.35546,538.09512l-.97627-.01907c.021-1.08114.63114-26.56133,10.66219-33.604l.56059.79893C304.97563,512.02955,304.36022,537.83532,304.35546,538.09512Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#44bba4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.19984,
    cy: 327.76848,
    r: 4.88134,
    fill: "#44bba4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M318.2161,516.50423a15.19762,15.19762,0,0,1-7.84148.33859,13.85016,13.85016,0,0,1,14.23984-4.88441A15.19753,15.19753,0,0,1,318.2161,516.50423Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#44bba4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M444.35546,538.09512l-.97627-.01907c.021-1.08114.63114-26.56133,10.66219-33.604l.56059.79893C444.97563,512.02955,444.36022,537.83532,444.35546,538.09512Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#44bba4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.19984,
    cy: 327.76848,
    r: 4.88134,
    fill: "#44bba4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M458.2161,516.50423a15.19762,15.19762,0,0,1-7.84148.33859,13.85016,13.85016,0,0,1,14.23984-4.88441A15.19753,15.19753,0,0,1,458.2161,516.50423Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#44bba4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M555.99683,665.5h-479v-277h479Zm-477-2h475v-273h-475Z",
    transform: "translate(-71.00317 -171.5)",
    fill: "#2f2e41"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 6.99365,
    y: 237.06494,
    width: 477,
    height: 2,
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev1);
export default __webpack_public_path__ + "static/media/web-dev1.6c170d9a65268dbc13bc67d79196d40b.svg";
export { ForwardRef as ReactComponent };